import React from "react";

import { Row, Col, FormGroup, Label } from 'reactstrap';
import { useNavigate } from "react-router-dom";

import * as Yup from "yup";
import { Formik, Form, Field } from 'formik';
import { sendEmail } from '../../../../api';
import store from '../../../../store/store';

import Select from 'react-select';
import './style.scss'; 
import BaseButton from "../../../common/BaseButton";
import contactsLeftArc from '../../../../assets/images/contactsLeftArc.png';
import contactsTopArc from '../../../../assets/images/contactsTopArc.png';
import { FormSelectCountries } from '../../../../contants';
import { openPreloaderAction, closePreloaderAction, setToastifyAction } from '../../../../store/actions';

export default function ContactForm () {
    let navigate = useNavigate();
    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

    const ContactFormValidationSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Required'),
        company: Yup.string()
            .required('Required'),
        email: Yup.string()
            .required('Required')
            .email('Please provide a valid Email'),
        phone: Yup.string()
            .required('Required')   
            .matches(phoneRegExp, 'Phone number is not valid'),
        privacyAgree: Yup.bool() 
            .oneOf([true], "You must accept the terms and conditions"),
        message: Yup.string()
            .min(2, 'Too Short!')
            .required('Required'),
   });

    return (
        <Row className="justify-content-center">
            <Col className="contact-form-container" md={5}>
                <img src={contactsLeftArc} className="contacts-left-arc" alt="contacts left arc"/>
                <img src={contactsTopArc} className="contacts-top-arc" alt="contacts top arc"/>
                <h4>Contact information</h4>
                 <Formik
                    initialValues={{
                        name: '',
                        company: '',
                        email: '',
                        country: FormSelectCountries[33],
                        phone: '',
                        message: '',
                        privacyAgree: false,
                    }}
                    validationSchema={ContactFormValidationSchema}
                    onSubmit={(values, { resetForm }) => {
                        const {name, company, email, country, phone, message } = values;

                        const payload = {
                            name,
                            company,
                            email,
                            country: country.value,
                            phone,
                            email,
                            message
                        };

                        store.dispatch(openPreloaderAction());
                        sendEmail(payload)
                            .then((data) => {
                                store.dispatch(setToastifyAction({value: `Thanks for reaching out! We'll get back to you shortly.`}));
                                resetForm();
                            })
                            .catch(error => store.dispatch(setToastifyAction({value: `Oops! Something went wrong.`, isError: true})))
                            .finally(() => store.dispatch(closePreloaderAction()));
                            
                    }}
                >
                    {({ errors, touched, values, setFieldValue }) => (
                        <Form>
                            <FormGroup className="form-group">
                                <Field className={`form-control ${errors.name && touched.name ? 'error-input' : ''}`} name="name"/>
                                {errors.name && touched.name ? (
                                    <div className="form-error">{errors.name}</div>
                                ) : null}
                                <span className={`floating-label ${values.name ? 'filled-input' : ''}`}>Name</span>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Field className={`form-control ${errors.company && touched.company ? 'error-input' : ''}`} name="company"/>
                                {errors.company && touched.company ? (
                                    <div className="form-error">{errors.company}</div>
                                ) : null}
                                <span className={`floating-label ${values.company ? 'filled-input' : ''}`}>Company name</span>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Field className={`form-control ${errors.email && touched.email ? 'error-input' : ''}`} name="email" type="email" />
                                {errors.email && touched.email ? (
                                    <div className="form-error">{errors.email}</div>
                                ) : null}
                                <span className={`floating-label ${values.email ? 'filled-input' : ''}`}>E-mail</span>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Select
                                    className={`contact-select-countries`}
                                    classNamePrefix="select"
                                    name="country"
                                    options={FormSelectCountries}
                                    id="country"
                                    value={values.country}
                                    onChange={(selectedCountry) =>
                                        setFieldValue('country', selectedCountry)
                                    }
                                />
                                <span className='floating-label filled-input'>Select country</span>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Field  className={`form-control ${errors.phone && touched.phone ? 'error-input' : ''}`} name="phone"/>
                                {errors.phone && touched.phone ? (
                                    <div className="form-error">{errors.phone}</div>
                                ) : null}
                                <span className={`floating-label ${values.phone ? 'filled-input' : ''}`}>Phone number</span>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Field className={`form-control ${errors.message && touched.message ? 'error-input' : ''}`} name="message" as="textarea"/>
                                <span className={`floating-label ${values.message ? 'filled-input' : ''}`}>Message</span>
                                {errors.message && touched.message ? (
                                    <div className="form-error textarea-error">{errors.message}</div>
                                ) : null}
                            </FormGroup>
                            <FormGroup check>
                                <Field className="checkbox-form" name="privacyAgree" type="checkbox"/>
                                <Label check>
                                    I agree to the <a target="_blank" href={`${process.env.PUBLIC_URL}/PrivacyPolicy.pdf`}>Privacy Notice</a>
                                </Label>
                                {errors.privacyAgree && touched.privacyAgree ? (
                                    <div className="form-error form-error-privacy">{errors.privacyAgree}</div>
                                ) : null}
                            </FormGroup>
                            <BaseButton
                                text={"Submit"}
                                type={"submit"}
                                className={"submit-form-btn"}
                                onClick={() => navigate('/contacts')}
                            />
                            <p className="privacy-terms-text">Secured with ReCAPTCHA. <a target="_blank" href={`${process.env.PUBLIC_URL}/PrivacyPolicy.pdf`}>Privacy Policy</a></p>
                        </Form>
                    )}
                </Formik>
            </Col>
        </Row>
    )
}
